module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-1-Appearance-Ideals-in-the-Media-ES-d0d1052ef64fa93ac5e02b1778eae54b.pdf";